module.exports = __webpack_public_path__ + "media/components/partials/LandingComponents/General/Footer/img/facebook-b9b5d50d0736ee2c37834275f6b985a2.svg";